module.exports = __webpack_public_path__ + "static/media/lines.0b9a6938.svg";